/**
 * Terms of Service Page (v0.10.0 - Issue #387)
 *
 * Clear, modern terms of service for all users.
 * Content lives in data/content/terms.ts (#2212 — shared with the
 * native Terms screen).
 */

import PageLayout from '../components/PageLayout';
import ContentDocView from '../components/ContentDocView';
import { TERMS_DOC } from '../data/content/terms';

export default function TermsPage() {
  return (
    <PageLayout title="Terms">
      <ContentDocView doc={TERMS_DOC} />
    </PageLayout>
  );
}
